module.exports = __webpack_public_path__ + "static/img/association.ccb68fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/association.png
// module id = MzKP
// module chunks = 1